import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { createThunkErrorHandler } from '../../utils/handleThunkError.js';
import { handlePending } from '../../utils/handlePending.js';
import { add, getAllLinks } from '../../http/linksAPI';


export const addLink = createAsyncThunk(
    'links/addLink',
    async (linkData, { rejectWithValue }) => {
        try {
            const data = await add(linkData)
            return data
        } catch (e) {
            return rejectWithValue(e?.code || 'Add link failed')
        }
    }
);

export const getUsersLinks = createAsyncThunk(
    'links/getUsersLinks',
    async function (params = {}, { rejectWithValue, dispatch, getState }) {

        dispatch(clearErrors())
        const state = getState().links;
        const page = params.page ?? state.page;
        const limit = params.limit ?? state.limit;

        try {
            const data = await getAllLinks(page, limit)
            return data
        } catch (e) {
            return rejectWithValue(e?.code || 'Failed')
        }
    }
)

const linksSlice = createSlice({
    name: 'links',
    initialState: {

        errors: {},
        globalError: null,
        isLoading: false,
        showSuccess: false,
        count: 0,
        limit: 30,
        page: 1,
        data: []


    },
    reducers: {


        clearErrors: (state) => {
            state.errors = {}
            state.globalError = null
        },

        clearGlobalError: (state) => {
            state.globalError = null
        },

        clearShowSuccess: (state) => {
            state.showSuccess = false
        },

        setPage: (state, action) => {
            const { page } = action.payload;
            state.page = page;
        }


    },

    extraReducers: builder => {
        builder
            .addCase(addLink.pending, handlePending)
            .addCase(addLink.rejected, createThunkErrorHandler("LINKS"))
            .addCase(addLink.fulfilled, (state) => {
                state.isLoading = false
                state.errors = {}
                state.globalError = null
                state.showSuccess = true
            })

            .addCase(getUsersLinks.pending, handlePending)
            .addCase(getUsersLinks.rejected, createThunkErrorHandler("LINKS"))
            .addCase(getUsersLinks.fulfilled, (state, action) => {

                state.isLoading = false
                state.errors = {}
                state.globalError = null
                state.data = action.payload.data
                state.count = action.payload.count
            })


    }
});

export const {

    clearErrors,
    clearGlobalError,
    clearShowSuccess,
    setPage,

} = linksSlice.actions;

export default linksSlice.reducer;